import { Api } from '../api';
import { IListagemRole } from 'shared/types';

const getAll = async (): Promise<IListagemRole[] | Error> => {
  try {
    const { data, status } = await Api.get('/roles');
    if (data) {
      return data;
    }
    if (status === 204) {
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

export const RolesService = {
  getAll
};
